import { useFeatureValue } from '@growthbook/growthbook-react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js';
import { observer } from 'mobx-react-lite';
import { useMst } from '../../../models/rootModel';
import { SignupWithPayment } from './SignupWithPayment';
import { SignupWithPaymentStepProps } from './SignupWithPayment.type';
import { SignupWithPaymentV2 } from './SignupWithPaymentV2';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY!);

export const SignupWithPaymentStep = observer((props: SignupWithPaymentStepProps) => {
  const {
    UserPayment: { getChoosenPlan, klarnaOnly },
  } = useMst();
  const { isActive } = props;
  const useExtendedWebPayment = useFeatureValue('use_extended_web_payment', false);

  const plan = getChoosenPlan();

  if (!isActive) {
    return null;
  }

  if (useExtendedWebPayment && plan) {
    const elementsOptions: StripeElementsOptions =
      plan.type === 'one_time'
        ? {
            locale: 'en',
            loader: 'always',
            mode: 'payment',
            amount: plan?.amount,
            currency: plan?.currency,
            capture_method: 'manual',
            ...(klarnaOnly && { paymentMethodTypes: ['klarna'] }),
          }
        : {
            locale: 'en',
            loader: 'always',
            mode: 'subscription',
            amount: plan?.amount,
            currency: plan?.currency,
          };

    return (
      <Elements stripe={stripePromise} options={elementsOptions}>
        {isActive ? <SignupWithPaymentV2 {...props} /> : null}
      </Elements>
    );
  }

  return <Elements stripe={stripePromise}>{isActive ? <SignupWithPayment {...props} /> : null}</Elements>;
});
